export default "__VITE_ASSET__BkpmTRNe__"